import React from 'react'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Alert } from '@/components/ui/alert'
import { Spinner } from '@/components/ui/spinner'

export default function PasswordReset({
  show,
  hasError,
  error,
  loading,
  username,
  verificationCode,
  newPassword,
  repeatPassword,
  requiresVerificationCode,
  verificationCodeSent,
  reportUsername,
  reportNewPassword,
  reportRepeatPassword,
  reportVerificationCode,
  requestClose,
  requestPasswordReset
}) {
  return (
    <Dialog open={!!show} onOpenChange={o => { if (!o) requestClose() }}>
      <DialogContent onEscapeKeyDown={e => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>Reset Password</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-3">
          {hasError && <Alert variant="error">{error}</Alert>}
          {verificationCodeSent && <Alert variant="success">Verification code sent to your email</Alert>}

          <div className="space-y-1.5">
            <Label htmlFor="pr-username">Username</Label>
            <Input
              id="pr-username"
              type="text"
              value={username || ''}
              placeholder="Your email address in all lowercase"
              onChange={e => reportUsername(e.target.value)}
            />
          </div>

          {requiresVerificationCode && (
            <div className="space-y-1.5">
              <Label htmlFor="pr-code">Verification Code</Label>
              <Input
                id="pr-code"
                type="text"
                value={verificationCode || ''}
                onChange={e => reportVerificationCode(e.target.value)}
              />
              <p className="text-xs text-muted-foreground">
                Check your inbox for a code from no-reply@aberdeen.io — also check your junk folder.
              </p>
            </div>
          )}

          <div className="space-y-1.5">
            <Label htmlFor="pr-new">New Password</Label>
            <Input
              id="pr-new"
              type="password"
              autoFocus
              value={newPassword || ''}
              onChange={e => reportNewPassword(e.target.value)}
            />
            <p className="text-xs text-muted-foreground">
              Requires at least one number, one special character, and an uppercase letter
            </p>
          </div>

          <div className="space-y-1.5">
            <Label htmlFor="pr-repeat">Repeat Password</Label>
            <Input
              id="pr-repeat"
              type="password"
              value={repeatPassword || ''}
              onChange={e => reportRepeatPassword(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') requestPasswordReset() }}
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={requestClose}>Cancel</Button>
          <Button onClick={requestPasswordReset} disabled={loading}>
            {loading && <Spinner size={16} className="text-primary-foreground" />}
            {loading ? 'Submitting…' : 'Submit'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
